import React, { useState, useEffect } from "react";
import "./PortfolioShowCase.scss";
import { client } from "../../client";
import imageUrlBuilder from "@sanity/image-url";
import { useNavigate } from "react-router-dom";

/* ===== SANITY IMAGE BUILDER ===== */
const builder = imageUrlBuilder(client);
const urlFor = (source) =>
  source?.asset ? builder.image(source).width(1600).url() : "";

const PortfolioShowcase = ({ page }) => {
  const [current, setCurrent] = useState(0);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  /* ===== FETCH FROM SANITY ===== */
  useEffect(() => {
    client
      .fetch(
        `*[_type == "portfolioShowcase" && page == $page][0]{
          category,
          title,
          shortDescription,
          buttonText,
          images[]{
            image,
            description
          }
        }`,
        { page }
      )
      .then(setData)
      .catch(console.error);
  }, [page]);

  /* ===== AUTO SLIDER ===== */
  useEffect(() => {
    if (!data?.images || data.images.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % data.images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [data?.images]);

  if (!data) return null;

  const currentImage = data.images[current];

  return (
    <section className="portfolio-showcase">
      {/* Header */}
      <div className="portfolio-showcase__header">
        <span>{data.category}</span>
        <h2>{data.title}</h2>
        <p>{data.shortDescription}</p>
      </div>

      {/* Slider */}
      <div className="portfolio-showcase__slider">
        <img
          src={urlFor(currentImage.image)}
          alt="project"
        />

        {/* DOTS */}
        <div className="slider-dots">
          {data.images.map((_, index) => (
            <span
              key={index}
              className={`dot ${current === index ? "active" : ""}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      {/* Content (🔥 IMAGE SPECIFIC DESCRIPTION) */}
      <div className="portfolio-showcase__content">
        <p>{currentImage.description}</p>
        <button 
          className="portfolio-btn"
          onClick={() => navigate("/projects")}
        >
          {data.buttonText}
        </button>
      </div>
    </section>
  );
};

export default PortfolioShowcase;
